import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';

const app = new useItem(gqlItem);
const apps = new useList(gqlList);

export default function() {
  return {
    app,
    apps
  };
}
